import { Rectangle, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import Table from '../table/condensed';
import TABLE_PROP_TYPES from '../../lib/prop-types/table';

const MatchCentreTable = ({ table, isMobile }) => {
  if (!table) {
    return <span>table placeholder</span>;
  }

  return (
    <Rectangle
      responsive={[
        {
          minWidth: 'fullHeader',
          props: { radius: '10px', border: '1px solid #d9d9d9' },
        },
      ]}
      style={{ overflow: 'hidden' }}
    >
      <Rectangle
        fill="#000"
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          padding: '12px',
          boxSizing: 'border-box',
        }}
        component="div"
      >
        <Typography size={18} weight="600" color="#fff">
          {table.name}
        </Typography>
      </Rectangle>
      <Table {...table} isV2 isMobile={isMobile} />
    </Rectangle>
  );
};

MatchCentreTable.defaultProps = {
  table: null,
  isMobile: false,
};

MatchCentreTable.propTypes = {
  table: TABLE_PROP_TYPES,
  isMobile: PropTypes.bool,
};

export default MatchCentreTable;
